import React from 'react';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import PaidStamp from '@assets/images/payment/paid.png';
import styles from './stagePayment.module.scss';
import { flowType } from '@utility/userInfo';

const PaymentTerminalStagePayment = ({
  tableData,
  currencySymbol,
  stageData,
  seatItems,
  stageInfo,
  onClickPaymentHandler,
  countryCode
}) => {
  const renderModifier = (modifiersObj) => (
    (modifiersObj || []).map((modifier) => (
      <div key={modifier.modifierId} className={modifier.price ? 'col-12 text-left p-0 fs-18' : 'd-none'}>
        {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName} ${modifier.price ? `(${LABEL().CURRENCY_SYMBOL}${modifier.price})` : ''}`}
        {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">
            {renderModifier(modifier.modifiers)}
          </div>
        )}
      </div>
    ))
  );
  const displaySeatTitle = () => {
    const seatNumbers = [];
    stageInfo.seats.forEach((seat) => {
      seatNumbers.push(seat.number);
    });
    return [seatNumbers.slice(0, -1).join(', '), seatNumbers.slice(-1)[0]].join(seatNumbers.length < 2 ? '' : ' & ');
  };

  return (
    <>
      {/* <div className="h-5 text-center py-1 od-text-primary text-primary">STAGE: {stageData.code}</div> */}
      <div className="h-5 text-center py-1 od-text-primary text-primary"><span className={styles.spanForPayment}>{stageData.code} {stageInfo?.seats?.length === 1 ? LABEL().SEAT : LABEL().SEATS} </span> {displaySeatTitle()}</div>
      {seatItems.length > 0 ? (
        <div className="h-60 p-3 border-bottom border-color-primary od-text-primary text-primary overflowY position-relative">
          {seatItems.map((item) => {
            return (
              <div key={item.menuItemId} className="row m-0 fw-700">
                <div className="col-9 p-0 text-left fs-18">
                  <div className="row mx-0">
                    <span className={cn('p-0 fs-16', styles.divForPayment)}>
                      {`${(item.quantity > 1 || tableData.splitValue > 1) ? `${item.quantity}${tableData.splitValue > 1 ? `/${tableData.splitValue} ` : ''}x ` : ''}`}{`${item.splitValueString}${item.menuItemName}`}
                    </span>
                    {/* <span className={cn('p-0', item.quantity > 1 || tableData.splitValue > 1 ? 'pl-1' : 'col-11')}>
                      {`${item.splitValueString}${item.menuItemName}`}
                    </span> */}
                  </div>
                </div>
                <div className="col-3 p-0  fs-18 text-right">
                  {currencySymbol}
                  {(item.price).toFixed(2)}
                </div>
                <div className="col-12 p-0">
                  {item.modifiers && renderModifier(item.modifiers)}
                  <div className="text-left pl-2 fs-18">
                    {`${item.note ? `- ${item.note}` : ''}`}
                  </div>
                </div>
                {stageData.status === 2 && (
                  <div className={cn('position-absolute text-primary fs-30 fw-800', styles.PaidStamp)}>
                    <img src={PaidStamp} alt="" height="100px" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : <div className="d-flex p-3 border-bottom border-color-primary od-text-primary text-primary overflowY fs-600 justify-content-center align-items-center h-60 fs-18">{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>}
      <div className="overflowY col-12 h-25 p-4 border-bottom border-color-primary od-text-primary text-primary overflowY mx-0 px-0">
        {countryCode === '44' ? (
          <div className="row m-0 fw-700 fs-18">
            <div className="col-6 p-0 text-left">{LABEL().TOTAL}</div>
            <div className="col-2 p-0 fs-18 text-right">
              {currencySymbol}{(stageInfo.totalAmount || stageInfo.totalAmount === 0) && stageInfo.totalAmount.toFixed(2)}
            </div>
          </div>
        ) : (
          <div className="row mx-0 fw-700 fs-18">
            <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().SUB_TOTAL}</div>
            <div className={cn('col-2 p-0 fs-18 text-right', styles.divForPayment)}>
              {currencySymbol}{(stageInfo.subTotalAmount || stageInfo.subTotalAmount === 0) && stageInfo.subTotalAmount.toFixed(2)}
            </div>
          </div>
        )}
        <div className="row mx-0 fw-700 fs-18">
          <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{countryCode === '44' ? LABEL().VAT : LABEL().TAX}</div>
          <div className={cn('col-2 p-0 fs-18 text-right', styles.divForPayment)}>
            {currencySymbol}{(stageInfo.taxAmount || stageInfo.taxAmount === 0) && stageInfo.taxAmount.toFixed(2)}
          </div>
        </div>
        <div className="row mx-0 fw-700 fs-18">
          <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().SERVICE_CHARGE}</div>
          <div className={cn('col-2 p-0 fs-18 text-right', styles.divForPayment)}>
            {currencySymbol}{stageInfo?.serviceChargeAmount.toFixed(2)}
          </div>
        </div>
        <div className="row mx-0 fw-700 fs-18">
          <div className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().DISCOUNT_AMOUNT}</div>
          <div className={cn('col-2 p-0 fs-18 text-right', styles.divForPayment)}>
            {currencySymbol}{stageInfo?.discountAmount.toFixed(2)}
          </div>
        </div>
        {countryCode !== '44' && (
          <div className="row m-0 fw-700 fs-18">
            <h4 className={cn('col-6 p-0 text-left', styles.divForPayment)}>{LABEL().PAYEMENT_TOTAL_DUE}</h4>
            <h4 className={cn('col-2 p-0 fs-26 text-right', styles.divForPaymentTotal)}>
              {currencySymbol}{(stageInfo.totalAmount || stageInfo.totalAmount === 0) && stageInfo.totalAmount.toFixed(2)}
            </h4>
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={() => { onClickPaymentHandler(stageInfo); }}
        disabled={stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0)}
        className={cn('text-center btn-primary btn-ripple h-10 d-flex justify-content-center align-items-center background-primary od-text-secondary text-secondary py-1 w-100 border-0', styles.payButton, stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0) ? 'disabledButton' : 'od-btn-primary', ['kiosk'].includes(flowType()) ? 'btn100' : 'btn50')}
        // style={{ bottom: '0px', borderBottomLeftRadius: '50px', borderBottomRightRadius: '50px' }}
      >
        {LABEL().PAY} 
      </button>
    </>
  );
};

export default PaymentTerminalStagePayment;
